// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container___15ER8","suggestionsContainerOpen":"styles__suggestionsContainerOpen___2OCyS","suggestionsList":"styles__suggestionsList___3p7wj"};